export const MSG_UPDATE_STATE = "MSG_UPDATE_STATE"
export const MSG_MORE_MESSAGES_LOADED = "MSG_MORE_MESSAGES_LOADED"
export const MSG_DELETED = "MSG_DELETED"
